import React from "react";
import styled from "styled-components";
import { PreviewInput } from "../../atoms/PreviewInput";
import { Owner } from "../../../ducks/owner/types";

type Props = {
    owner: Owner;
};

export const DetailOwnerForm: React.FC<Props> = ({ owner }) => {
    // Helper function to format date in a user-friendly way
    const formatDate = (dateString: string | null | undefined): string => {
        if (!dateString) return "N/A";

        try {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleDateString('en-US', { month: 'long' });
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        } catch (error) {
            console.error('Error formatting date:', error);
            return "Invalid Date";
        }
    };

    return (
        <>
            <StyledFormGrid>
                <PreviewInput
                    label="Name"
                    name="name"
                    value={owner.name}
                    fullWidth
                />
                <PreviewInput
                    label="Email"
                    name="email"
                    value={owner.email || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Phone Number"
                    name="phone_number"
                    value={owner.phone_number}
                    fullWidth
                />
                <PreviewInput
                    label="Other Phone Number"
                    name="other_phone_number"
                    value={owner.other_phone_number || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Created At"
                    name="created_at"
                    value={formatDate(owner.created_at)}
                    fullWidth
                />
            </StyledFormGrid>
        </>
    );
};

const StyledFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`; 